import { minutesToHourLabel } from './timeUtils'
import { useTimeFormat } from '../../../hooks/useTimeFormat'

const SCRIM = { background: 'rgba(0,0,0,0.5)', boxShadow: '0 0 6px 4px rgba(0,0,0,0.5)', transform: 'translateY(-50%)' }

/** Sticky hour marker on the schedule's time axis, centered on its gridline. */
export function HourLabel({ minutes }: { minutes: number }) {
  const { hourCycle } = useTimeFormat()
  return (
    <span className="text-[11px] font-medium text-on-image tabular-nums rounded-sm px-0.5" style={SCRIM}>
      {minutesToHourLabel(minutes, hourCycle)}
    </span>
  )
}
